import { render, staticRenderFns } from "./output_workbench.vue?vue&type=template&id=34777d87&scoped=true"
import script from "./output_workbench.vue?vue&type=script&lang=js"
export * from "./output_workbench.vue?vue&type=script&lang=js"
import style0 from "./output_workbench.vue?vue&type=style&index=0&id=34777d87&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34777d87",
  null
  
)

export default component.exports